import Hash from './Hash'
import autobind from 'autobind-decorator'

class HistoryBlockChain {
	constructor() {
		this.handlers = new Hash()
	}

	@autobind
	blockHandler(location, state) {

		if (`/manage${location.pathname}` === document.location.pathname) {
			return
		}

		return this.getBlockMessage()
	}

	@autobind
	unloadHandler(e) {
		const confirmationMessage = this.getBlockMessage()

		if (confirmationMessage) {
			e.returnValue = confirmationMessage
			return confirmationMessage
		}
	}

	getBlockMessage() {
		const list = this.handlers.list()
		for (let i = 0 ; i < list.length ; i++) {
			let handler = list[i]
			if (typeof handler === 'function') {
				let result = handler(...arguments)
				if (result) {
					return result
				}
			}
		}
	}

	add(handler) {
		this.handlers.add(handler)
	}

	remove(handler) {
		this.handlers.remove(handler)
	}
}

let instance = new HistoryBlockChain()

export default instance
